import { Http } from "../utils/http.js";
class News extends Http {
  infomationList(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Infomation/GetInfomationList",
      method: "post",
      param: param
    });
  }

  infomationDetail(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Infomation/GetInfomationDetail",
      method: "post",
      param: param
    });
  }
}
export { News };
